// extracted by css-extract-rspack-plugin
export default {"date_q":"BDsi8F_8UEBtv3k_","form":"IyAakC7TWdo_xuk0"};